// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/font-awesome/css/font-awesome.css
// module id = 935
// module chunks = 1